export default {
    money(value) {
        return "£" + Number(value || 0).toFixed(2).replace(/[.,]00$/, "");
    }
}
